import n from "react";
import a from "./index.es18.js";
import l from "./index.es56.js";
import s from "./index.es57.js";
import p from "./index.es58.js";
function b(t, o, i) {
  const r = t.name;
  if (!p(r))
    return null;
  const m = l(t.attribs, o);
  let e = null;
  return s.indexOf(r) === -1 && (e = a(t.children, i)), n.createElement(r, m, e);
}
export {
  b as default
};
//# sourceMappingURL=index.es35.js.map
